import { Star, MapPin } from "lucide-react";
import { HOME } from "@/constants/testIds";

const HERO_IMG =
    "https://images.unsplash.com/photo-1582870495095-bfe299c87a3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHx3ZXN0ZXJuJTIwZ2hhdHMlMjBrYXJuYXRha2ElMjB0cmF2ZWx8ZW58MHx8fHwxNzg1Mzg5MTE5fDA&ixlib=rb-4.1.0&q=85";

const Hero = () => {
    return (
        <section id="top" className="relative isolate overflow-hidden">
            <div className="absolute inset-0 -z-10">
                <img
                    src={HERO_IMG}
                    alt="Western Ghats"
                    className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-[#0f2118]/70 via-[#0f2118]/45 to-[#0f2118]/80" />
                <div className="absolute inset-0 noise-bg opacity-[0.35] mix-blend-overlay" />
            </div>

            <div className="mx-auto max-w-7xl px-5 md:px-10 pt-24 pb-32 md:pt-32 md:pb-40 text-[#FAFAF5]">
                <div className="flex items-center gap-4 text-sm">
                    <div className="flex items-center gap-1.5">
                        {[0, 1, 2, 3, 4].map((i) => (
                            <Star
                                key={i}
                                className="h-4 w-4 fill-[#C46A42] text-[#C46A42]"
                            />
                        ))}
                        <span className="ml-1 font-medium">5.0</span>
                    </div>
                    <span className="opacity-70">·</span>
                    <span className="opacity-90">23 Ratings</span>
                    <span className="opacity-70">·</span>
                    <span className="inline-flex items-center gap-1.5">
                        <MapPin className="h-4 w-4" /> Shivamogga
                    </span>
                </div>

                <h1 className="mt-8 font-display text-5xl md:text-7xl lg:text-[88px] leading-[1.02] max-w-4xl">
                    Journeys through the{" "}
                    <span className="italic text-[#F0C9A6]">Western Ghats</span>,
                    <br className="hidden md:block" /> planned with heart.
                </h1>

                <p className="mt-6 max-w-xl text-lg opacity-90 leading-relaxed">
                    Budget-friendly tour packages, spotless cabs and 24×7
                    support from Shivamogga's most-loved travel team.
                </p>

                <div className="mt-10 flex flex-wrap items-center gap-4">
                    <a
                        data-testid={HOME.heroPlanTrip}
                        href="#plan"
                        className="inline-flex items-center gap-2 rounded-full bg-[#C46A42] text-white px-7 py-3.5 text-base hover:bg-[#A5583A] hover:-translate-y-0.5 transition-[transform,background-color] duration-200 shadow-lg"
                    >
                        Plan My Trip
                    </a>
                    <a
                        data-testid={HOME.heroExplore}
                        href="#packages"
                        className="inline-flex items-center gap-2 rounded-full border border-white/40 bg-white/10 text-white px-7 py-3.5 text-base hover:bg-white/20 hover:-translate-y-0.5 transition-[transform,background-color] duration-200 backdrop-blur"
                    >
                        Explore Packages
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Hero;
